<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    :stroke-width="strokeWidth"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <path d="M15 18l-6-6 6-6" />
  </svg>
</template>

<script>
export default {
  name: 'IconChevronLeft',
  props: {
    size: { type: [String, Number], default: 14 },
    strokeWidth: { type: [String, Number], default: 2.4 },
  },
};
</script>
